import React, { useEffect } from "react";
import axios from "axios";
import TimeAgo from "../TimeAgo";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { decrementUnseen } from "../../../app/slices/userSlice";
import { apiUrl } from "../../../utils/backendUrl";
import styles from "./Notification.module.css";

function Notification({ toast, t, notification }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const markAsRead = () => {
    if (notification?._id) {
      axios
        .patch(
          apiUrl(`/api/v1/notifications/${notification._id}/read`),
          {},
          { withCredentials: true }
        )
        .then(() => {
          dispatch(decrementUnseen({ type: "notification" }));
        })
        .catch(() => {});
    }
  };

  // This popup is a react-hot-toast CUSTOM toast, so the library draws nothing
  // for it and animates nothing: `toast.dismiss` only flips `t.visible` and
  // queues the real removal a second later. react-hot-toast 2.4.0 then cancels
  // that removal if the toast's DOM changes in the meantime (its height
  // observer dispatches an update) and never queues it again, which stranded
  // this popup on screen with a dead X. So the popup never waits for the
  // library: it removes itself outright, and it stops rendering the moment it
  // is no longer visible (which also covers the 8-second auto-dismiss).
  const toastId = t?.id;
  const visible = t?.visible !== false;

  useEffect(() => {
    if (!visible && toastId) toast.remove(toastId);
  }, [visible, toastId, toast]);

  const closeToast = () => {
    if (toastId) toast.remove(toastId);
  };

  const handleDismiss = (event) => {
    event?.stopPropagation?.();
    markAsRead();
    closeToast();
  };

  if (!visible) return null;

  return (
    <div className={`${styles.main}`} data-testid="notification-toast">
      <div className={styles.header}>
        <span>New notification</span>
        <button
          type="button"
          onClick={handleDismiss}
          className={`small_circle ${styles.dismiss}`}
          aria-label="Dismiss notification"
          data-testid="notification-toast-dismiss"
        >
          <i
            className="exit_icon"
            aria-hidden="true"
            style={{
              transform: "scale(0.7)",
            }}
          ></i>
        </button>
      </div>
      <div
        className={styles.content}
        onClick={() => {
          markAsRead();
          closeToast();
          if (notification?.click) navigate(notification.click);
        }}
      >
        <div className={styles.img}>
          <img
            src={notification?.sender?.photo || notification?.actor?.photo || "/images/default_pic.png"}
            alt=""
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/images/default_pic.png";
            }}
          />
          <img
            className={styles.type}
            src={`../../../reacts/${
              notification.type === "react"
                ? notification.content.split(" ")[2]
                : notification.type
            }.svg`}
            alt=""
          />
        </div>
        <div className={styles.content_2}>
          <span>{notification.content}</span>
          <span className={styles.time}>
            <TimeAgo interval={30}>
              {notification.createdAt}
            </TimeAgo>
          </span>
        </div>
        <div>
          <p
            style={{
              background: `#0096ff`,
              width: "12px",
              height: "12px",
              borderRadius: "100%",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Notification;
